import { Button } from '@material-ui/core';
import React from 'react';
import Cookies from 'universal-cookie';
import NuovaRicostruzione from '../../components/NewQuestion/NuovaRicostruzione';
import NuovaSceltaMultipla from '../../components/NewQuestion/NuovaSceltaMultipla';
import NuovoAudioMultipla from '../../components/NewQuestion/NuovoAudioMultipla';
import NuovoAudioVF from '../../components/NewQuestion/NuovoAudioVF';
import NuovoCloze from '../../components/NewQuestion/NuovoCloze';
import NuovoCompletamento from '../../components/NewQuestion/NuovoCompletamento';
import NuovoTestoImmagine from '../../components/NewQuestion/NuovoTestoImmagine';
import NuovoTestoTesto from '../../components/NewQuestion/NuovoTestoTesto';
import NuovoVF from '../../components/NewQuestion/NuovoVF';
import PageTitle from '../../components/PageTitle/PageTitle';
import checkUtente from '../../services/checkUtente';
import getEventsListService from '../../services/getMaterie';
import translateString from '../../utils/Locales';
import getInsegnanti from '../../services/getInsegnanti';
import createTest from '../../services/createTest';
import { domande } from '../../utils/tipologie';
import addDomanda from '../../services/addDomanda';
import moment from "moment";
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

const cookies = new Cookies();
let t = translateString;

export default class NewExam extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            id: undefined,
            isLoading: true, 
            titolo: '', 
            event: undefined,
            tipoDomande: [],
            domande: [],
            materie: [],
            refs: [],
            materiaId: undefined,
            newQuestion: false,
            uploading: false, 
            questionCount: 0,
            value:undefined,
            dateActivation: moment().format('yyyy-MM-DD HH:mm'),
            durata: 0,
            alertTitolo: false,
            alertMateria: false,
            alertDurata: false,
        };
    }

    async componentDidMount() {
        this.load()
        this.addNewQuestion();
    }

    async load() {
        let username = cookies.get('username');
        let token = cookies.get('token');
        this.utente = await checkUtente(username, token, username);
        this.insegnanti = await getInsegnanti(username, token);
        this.currUtente = this.insegnanti.filter((insegnante) => insegnante.id === this.utente[0].user_id)[0];
        let materie = [];
        let arrayMaterie = await getEventsListService(username, token);
        arrayMaterie.forEach( element => {
            if (this.currUtente.id === element.id_insegnante) {
                materie.push(element)
            }
        })
        this.setState({materie})
    }

    async addNewQuestion(event) {
        if (event) {
            var q = this.state.tipoDomande;
            q.push(event);
            var d = this.state.domande;
            d.push({});
            let res = React.createRef();
            var refs = this.state.refs;
            refs.push(res);
            

            this.setState({ tipoDomande: q, domande: d, refs});            
        }

    }

    async sendDomande() {

        let username = cookies.get('username');
        let token = cookies.get('token');
        const currentCourse = cookies.get('currentCourse', { path: '/' });
        var id = this.state.id
        if (!this.state.id) {
            let create = await createTest(username, token, this.state.titolo, this.state.materiaId, currentCourse, this.state.dateActivation, this.state.durata)
            
            if (create.result === 'KO') {
                alert("no bueno");
                return;
            }
            id = create.id;
            this.setState({id})
        }    
        var confirm = true;
        let domande = [];
        this.state.refs.forEach((r, ind) => {

            var domanda = r.current.getQuestion();
            if (!domanda) {
                confirm = false;
                return;
            }

            if (domanda.tipo === 'deleted') {
                return;
            }

            domanda.refInd = ind;
            domande.push(domanda);
        });

        if (!confirm) { 
            alert('Sono stati rilevati alcuni errori all\'interno delle domande create. Per favore, verifica tutti i dati e riprova.');
            return;
        }

        this.setState({ uploading: true, questionCount: 0 });

        let domandeFinali = [];
        let risposteFinali = [];

        domande.forEach((d) => {
            
            if (d.tipo === 0) {
                
                // Vero o Falso 
                let obj = {
                    tipo: 0, 
                    domanda: d.domanda, 
                    risposte: '',
                    audio: '',
                    allegato: d.allegato
                };
                domandeFinali.push(obj);

                let obj2 = {
                    risposta_corretta: d.risposta 
                };
                risposteFinali.push(obj2);
            } else if (d.tipo === 1) {

                // Risposta multipla
                let obj = {
                    tipo: 1, 
                    domanda: d.domanda, 
                    risposte: JSON.stringify(d.risposte),
                    audio: '',
                    allegato: d.allegato,
                };
                domandeFinali.push(obj);

                let obj2 = {
                    risposta_corretta: d.risposta 
                };
                risposteFinali.push(obj2);
            } else if (d.tipo === 2) {
                
                // Abbinamento testo - testo 
                let obj = {
                    tipo: 2, 
                    domanda: JSON.stringify(d.domande), 
                    risposte: JSON.stringify(d.risposte),
                    audio: '',
                    allegato: null, 
                };
                domandeFinali.push(obj);

                let obj2 = {
                    risposta_corretta: '',  
                };
                risposteFinali.push(obj2);
            } else if (d.tipo === 3) {

                // Abbinamento testo - immagine 
                let obj = {
                    tipo: 3, 
                    domanda: JSON.stringify(d.domande), 
                    risposte: JSON.stringify(d.risposte),
                    audio: '',
                    allegato: null, 
                };
                domandeFinali.push(obj);

                let obj2 = {
                    risposta_corretta: '',  
                };
                risposteFinali.push(obj2);
            } else if (d.tipo === 4) {

                // Audio - Vero/Falso
                let obj = {
                    tipo: 4, 
                    domanda: d.domanda, 
                    risposte: '',
                    audio: d.audio,
                    allegato: null, 
                };
                domandeFinali.push(obj);

                let obj2 = {
                    risposta_corretta: d.risposta,  
                };
                risposteFinali.push(obj2);
            } else if (d.tipo === 5) {

                // Audio - Risposta multipla
                let obj = {
                    tipo: 5, 
                    domanda: d.domanda, 
                    risposte: JSON.stringify(d.risposte),
                    audio: d.audio,
                    allegato: null, 
                };
                domandeFinali.push(obj);

                let obj2 = {
                    risposta_corretta: d.risposta,  
                };
                risposteFinali.push(obj2);
            } else if (d.tipo === 6) {

                // Cloze
                let obj = {
                    tipo: 6, 
                    domanda: d.domanda, 
                    risposte: JSON.stringify(d.risposte),
                    audio: '',
                    allegato: null, 
                };
                domandeFinali.push(obj);

                let obj2 = {
                    risposta_corretta: '',  
                };
                risposteFinali.push(obj2);
            } else if (d.tipo === 7) {
            
                // Ricostruzione concettuale
                let obj = {
                    tipo: 7, 
                    domanda: d.domanda, 
                    risposte: JSON.stringify(d.risposte),
                    audio: '',
                    allegato: null, 
                };
                domandeFinali.push(obj);

                let obj2 = {
                    risposta_corretta: '',  
                };
                risposteFinali.push(obj2);
            } else if (d.tipo === 8) {

                // Completamento affermazione
                let obj = {
                    tipo: 8, 
                    domanda: d.domanda, 
                    risposte: JSON.stringify(d.risposte),
                    audio: '',
                    allegato: null, 
                };
                domandeFinali.push(obj);

                let obj2 = {
                    risposta_corretta: d.risposta,  
                };
                risposteFinali.push(obj2);
            }

        });

        // Upload
        var indexes = [];
        var count = 0;
        console.log(domandeFinali);
        domandeFinali.forEach((d, ind) => {
            
            let username = cookies.get('username');
            let token = cookies.get('token');
            addDomanda(username, token, id, d, risposteFinali[ind]).then((res) => {
                if (res.result === 'ok') {
                    indexes.push(ind);
                    console.log(res);
                }
                
                count++;
                this.setState({ questionCount: count + 1 });
                if (count === domandeFinali.length) {
                    this.notifyResult(indexes, domande, domandeFinali.length);
                } 
            });
        });

    }

    notifyResult(indexes, domande, count) {

        this.setState({ uploading: false });
        
        indexes.forEach((i) => {
            let ind = domande[i].refInd;
            this.state.refs[ind].current.delete();
        });

        if (indexes.length === count) {
            alert('Caricamento completato con successo.');
            cookies.get('db_path', { path: '/' });
            window.location.href =  "/" + cookies.get('db_path', { path: '/' }) + '/#/app/esamiCorso';
            return;
        }

        alert('Si sono verificati alcuni errori durante il caricamento. Le domande rimaste visibili NON sono state caricate. Per favore, riprova.');
        return;
    }


    render() {

        return(
            <div style={{marginTop: 50}}>
                <PageTitle title={t('nuovo_esame')} />
                <input type="text" placeholder={t('ins_nome_esame')}
                    style={{padding:8, width: '50%'}}
                    onChange={(event)=>{
                        this.setState({titolo: event.target.value, alertTitolo: false})
                    }}
                />
                {
                    this.state.alertTitolo && (
                        <Alert style={{borderRadius: 10, width: '50%'}} severity="error">{t('ins_nome_esame')}</Alert>
                    )
                }
                <div style={{marginTop: 20}}>
                    <select style={{padding: 8, width: '50%'}}
                    onChange={(e => this.setState({materiaId: e.target.value, alertMateria: false}) )}
                    >
                        <option value={undefined}>{t('scegli_materia')}</option>
                        {
                            this.state.materie.map((materia) => {
                                return(
                                    <option value={materia.id}>{materia.materia}</option>
                                )   
                            })
                        }
                    </select>
                    {
                        this.state.alertMateria && (
                            <Alert style={{borderRadius: 10, width: '50%'}} severity="error">{t('scegli_materia')}</Alert>
                        )
                    }
                </div>
                <div style={{marginTop: 20}}>
                    <select style={{padding: 8, width: '50%'}}
                    onChange={(e => { this.addNewQuestion(e.target.value)} )}
                    >
                        <option value={undefined}>{t('scegli_tipo_domanda')}</option>
                        {
                            domande.map((tipo) => {
                                return(
                                    <option value={tipo.value}>{tipo.label}</option>
                                )   
                            })
                        }
                    </select>
                    
                </div>
                <div style={{marginTop: 20, width: '50%'}}>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                        <Stack spacing={3} direction="row">
                            <DateTimePicker
                                label={t('seleziona_date')}
                                renderInput={(params) => <TextField {...params} />}
                                value={moment(this.state.dateActivation, "yyyy-MM-DD HH:mm").toDate()}
                                onChange={(date) => {
                                    var parsedDate = moment(date).format('yyyy-MM-DD HH:mm');
                                    this.setState({dateActivation: parsedDate})
                                }}
                            />
                            <TimePicker
                                ampm={false}
                                openTo="hours"
                                views={['hours', 'minutes', 'seconds']}
                                inputFormat="HH:mm:ss"
                                mask="__:__:__"
                                label={t('durata_test')}
                                value={moment(this.state.durata, "HH:mm:ss").toDate()}
                                onChange={(time) => {
                                    var parsedTime = moment(time).format('HH:mm:ss');
                                    this.setState({durata: parsedTime, alertDurata: false})
                                }}
                                renderInput={(params) => <TextField {...params} />}
                            />
                            {
                                this.state.alertDurata && (
                                    <Alert style={{borderRadius: 10, width: '50%'}} severity="error">{t('durata_test')}</Alert>
                                )
                            }
                        </Stack>
                    </LocalizationProvider>
                </div>
                { this.state.tipoDomande.length > 0 && ( 
                    <div style={{ marginTop: 10 }}>
                        <div style={{ marginTop: 20 }}>
                            { this.state.tipoDomande.map((tipo, ind) => {
                                if (tipo == 0) {
                                    return (
                                        <NuovoVF key={ind} ref={this.state.refs[ind]} />
                                    );
                                } else if (tipo == 1) {
                                    return(
                                        <NuovaSceltaMultipla key={ind} ref={this.state.refs[ind]} />
                                    );
                                } else if (tipo == 2) {
                                    return (
                                        <NuovoTestoTesto key={ind} ref={this.state.refs[ind]} />
                                    );
                                } else if (tipo == 3) {
                                    return(
                                        <NuovoTestoImmagine key={ind} ref={this.state.refs[ind]} />
                                    );
                                } else if (tipo == 4) {
                                    return(
                                        <NuovoAudioVF key={ind} ref={this.state.refs[ind]} />
                                    );
                                } else if (tipo == 5) {
                                    return(
                                        <NuovoAudioMultipla key={ind} ref={this.state.refs[ind]} />
                                    );
                                } else if (tipo == 6) {
                                    return(
                                        <NuovoCloze key={ind} ref={this.state.refs[ind]} />
                                    );
                                } else if (tipo == 7) {
                                    return(
                                        <NuovaRicostruzione key={ind} ref={this.state.refs[ind]} />
                                    );
                                } else if (tipo == 8) {
                                    return(
                                        <NuovoCompletamento key={ind} ref={this.state.refs[ind]} />
                                    );
                                }
                                return <></>;
                            })}
                            { this.state.tipoDomande.length > 0 && (
                            <div style={{ marginTop: 20 }}>
                                <button style={{ marginTop: 30, backgroundColor: '#1877F2', color: 'white', padding: 10, border: 0, width: '100%', borderRadius: '5px', cursor:'pointer' }} onClick={() => {
                                    if (this.state.titolo.trim().length !== 0) {
                                        if (this.state.materiaId !== undefined) {
                                            if (this.state.durata !== 0) {
                                                !this.state.uploading && this.sendDomande()
                                            } else {
                                                this.setState({alertDurata: true})
                                            }
                                        } else {
                                            this.setState({alertMateria: true})
                                        }
                                    } else {
                                        this.setState({alertTitolo: true})
                                    }
                                    }}>{!this.state.uploading ? 'INVIA DOMANDE' : 'INVIO... ' + this.state.questionCount + '/' + this.state.tipoDomande.length}</button>
                            </div>
                        )}
                        </div>
                    </div>
                )}
            </div>
        );
    }

}